import type { FC } from 'react';

import { Validation } from './components';
import type { TValidationsProps } from './types';

const Validations: FC<TValidationsProps> = ({ validations }) => {
  if (!validations) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-gap-1.2">
      {validations.map((validation, i) => {
        // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
        return <Validation key={`validation-${i * 1}`} {...validation} />;
      })}
    </div>
  );
};

export default Validations;
